import React from "react";
import { getDateString } from "../../../utils/dateutils";
import TableActions from "./actions/TableActions";
import "./careplancard.css";
import { getFullName } from "../../careprovider/visits/utils";
import { getUserAge } from "../../../utils/userdatautils";
import Services from "./volunteerservices/Services";
import TruncatedListWithPopover from "./TruncatedListWithPopover";
import Frequency from "./visitlist/Frequency";
import { useGetRole } from "../../generic/hooks/useGetRole";
import { useNavigate } from "react-router-dom";
import { RoleToLinkMapper } from "../../utils/UrlUtils";
import SmartIcon from "../../../components/generic/genericIcon/SmartIcon";
import CoordinatorCard from "./coordinator/CoordinatorCard";

const CarePlanCard = ({ careplan, showPatientInfo }) => {
  const role = useGetRole();
  const navigate = useNavigate();

  const patientAge =
    careplan?.patient?.birthDate && getUserAge(careplan?.patient?.birthDate);

  const { opportunities } = careplan;

  const assignedVolunteers = opportunities
    ?.filter((item) => item?.opportunityStatus === "Assigned")
    ?.map((item) =>
      getFullName(item?.workforce?.givenName, item?.workforce?.familyName),
    );

  const sharedOpportunities = opportunities?.filter(
    (item) => item?.opportunityStatus === "Shared",
  );

  const navigateToCareplanDetails = (carePlanId) => {
    navigate(
      `${RoleToLinkMapper(
        role,
      )}request-for-volunteering-service?carePlanId=${carePlanId}&assign=true`,
    );
  };

  const handleNavigation = () => {
    navigate(
      `${RoleToLinkMapper(role)}patient-profile?identifier=${
        careplan?.patient?.userIdentifier
      }`,
    );
  };

  return (
    <div>
      <div className="careplan-card-date-actions">
        <span>{getDateString(careplan?.requestDate)}</span>
        {careplan?.patientIdentifier && <TableActions careplan={careplan} />}
      </div>

      {careplan?.patient ? (
        <div className="patient-details-card-header">
          <span
            className="patient-details-card-primary-title cursor-pointer"
            onClick={handleNavigation}
          >
            {getFullName(
              careplan?.patient?.givenName,
              careplan?.patient?.familyName,
            )}
          </span>
          <span>(#{careplan?.patient?.medicalRecordNumber})</span>
          {showPatientInfo && (
            <span className="careplan-card-age">
              {careplan?.patient?.gender &&
                `${careplan?.patient?.gender?.charAt(
                  0,
                )}${careplan?.patient?.gender?.slice(1).toLowerCase()},`}
              {patientAge && !isNaN(patientAge) && ` Age ${patientAge}`}
            </span>
          )}
        </div>
      ) : (
        <span className="patient-details-card-primary-title">Office Work</span>
      )}

      <Services
        services={careplan?.services}
        status={careplan?.status}
        direction="horizontal"
      />
      {role === "Volunteer Coordinator" && (
        <div>
          {assignedVolunteers.length ? (
            <div className="careplan-card-assigned-volunteer">
              <SmartIcon iconKey={"volunteerGroup"} width={20} height={20} />
              <TruncatedListWithPopover
                dataList={assignedVolunteers}
                dataToBeDisplayed={3}
                direction="horizontal"
              />
            </div>
          ) : sharedOpportunities.length ? (
            <span>
              Shared with{" "}
              <span className="font-weight-bold">
                {sharedOpportunities.length}
              </span>{" "}
              {sharedOpportunities.length === 1 ? "volunteer" : "volunteers"}
            </span>
          ) : (
            <div
              className="assign-btn"
              onClick={() => navigateToCareplanDetails(careplan?.id)}
            >
              <SmartIcon
                iconKey={"volunteerRequest"}
                color="var(--main-theme-color)"
                width={20}
                height={20}
              />
              <span className="mt-1">Assign</span>
            </div>
          )}
        </div>
      )}

      <Frequency careplan={careplan} />
      {careplan?.coordinator && (
        <CoordinatorCard coordinator={careplan?.coordinator} />
      )}
    </div>
  );
};

export default CarePlanCard;
